import React, { useMemo } from 'react';
import { TaskSettingsContext, TaskSettingsContextProps, taskSettingsSlice } from '../context/TaskSettingsContext';
import { TaskSettings } from '../types/taskSettings';
import { useAppDispatch, useAppSelector } from '../ui/pages/store';

interface TaskSettingsProviderProps {
  children: React.ReactNode;
}

export default function TaskSettingsProvider({ children }: TaskSettingsProviderProps) {
  const dispatch = useAppDispatch();
  const items = useAppSelector(state => state.taskSettings.items);
  const loading = useAppSelector(state => state.taskSettings.loading);

  const taskSettings = useMemo(() => {
    return new Map(items.map(item => [item.id, new TaskSettings(item)]));
  }, [items]);

  const taskSettingsContext: TaskSettingsContextProps = {
    taskSettings,
    taskSettingsLoading: loading,
    setTaskSettings: (taskSettings: Map<string, TaskSettings>) =>
      dispatch(taskSettingsSlice.actions.setAll([...taskSettings.values()])),
  };

  return <TaskSettingsContext.Provider value={taskSettingsContext}>{children}</TaskSettingsContext.Provider>;
}
